module.exports = __webpack_public_path__ + "img/icon-label3.d9bbc54b.svg";